import store from "../storeWire";
import {
    destroy_cart_quote_active_session,
    getHeaderDetail,
    getLineItemsDetail,
    remove_all_quote_number_based_cart_quote_active_session,
    remove_quote_cart_line_item,
    toggle_quote_cart_line_item,
    select_all_quantity,
    set_schedule_date,
    getApprovedQuotes,
    quote_approved_list
} from "../store/slice/model/QuoteDetail";
import { useSelector } from "react-redux";
import System from "src/helper/system";
import produceClone from "src/helper/produceClone";
import QuoteDetailRepository from "src/repository/QuoteDetailRepository";

export function useQuoteDetailStore() {
    const quoteNumber = useSelector((state) => state.entities.model_QuoteDetail.quoteNumber);
    const cart_quote_active_session = useSelector((state) => state.entities.model_QuoteDetail.cart_quote_active_session);
    const quoteRequestedDate = useSelector((state) => state.entities.model_QuoteDetail.quoteRequestedDate);
    const quoteExpirationDate = useSelector((state) => state.entities.model_QuoteDetail.quoteExpirationDate);
    const contactName = useSelector((state) => state.entities.model_QuoteDetail.contactName);
    const contactEmail = useSelector((state) => state.entities.model_QuoteDetail.contactEmail);
    const contactPhone = useSelector((state) => state.entities.model_QuoteDetail.contactPhone);
    const line_items = useSelector((state) => state.entities.model_QuoteDetail.line_items);
    const approved_quote_list = useSelector((state) => state.entities.model_QuoteDetail.quote_approved_list);

    let data = {
        quoteNumber,
        quoteRequestedDate,
        quoteExpirationDate,
        contactName,
        contactEmail,
        contactPhone,
        line_items,
        cart_quote_active_session,
        approved_quote_list,
        get_cart_quote_active_session_by_quote_number: (quoteNumber) => {
            if (cart_quote_active_session[quoteNumber] !== undefined) {
                return cart_quote_active_session[quoteNumber];
            }
            return false;
        },
        get_current_quote_cart: () => {
            let quoteNumber = System.getParams().quote_number;
            if (quoteNumber && quoteNumber !== undefined) {
                if (cart_quote_active_session && cart_quote_active_session[quoteNumber] !== undefined) {
                    if (cart_quote_active_session[quoteNumber].records)
                        return cart_quote_active_session[quoteNumber].records;
                }
            }
            return false;
        },

        get_selected_current_tab_data: (qtList, quoteCurentStatus) => {
            if (qtList && Object.entries(qtList).length > 0) {
                let data = {};
                let dataList = produceClone(qtList);
                Object.entries(dataList).map((v) => {
                    if (v[1].status && v[1].status === quoteCurentStatus) {
                        data[v[0]] = v[1];
                    }
                });
                return data;
            }
            return false;
        }
    };
    let fetch = {
        fetch_quote_header_detail: async (quoteNumber, quoteProvisionalNumber) => {
            return await store.dispatch(getHeaderDetail({ quoteNumber, quoteProvisionalNumber }))
        },
        fetch_line_items: async (params) => {
            return await store.dispatch(getLineItemsDetail(params))
        },
        get_approved_quote_list: async (params) => {
            return await store.dispatch(getApprovedQuotes(params))
        }
    };
    let set = {
        toggle_quote_cart_line_item: (data) => {
            return store.dispatch(toggle_quote_cart_line_item({ data }))
        },
        remove_single_item_quote_cart_line_item: (data) => {
            data.quantity_field_selected = false;
            return store.dispatch(toggle_quote_cart_line_item({ data }))
        },
        remove_all_quote_number_based_cart_quote_active_session: (data) => {
            return store.dispatch(remove_all_quote_number_based_cart_quote_active_session({ data }))
        },
        destroy_cart_quote_active_session: () => {
            return store.dispatch(destroy_cart_quote_active_session())
        },
        remove_quote_cart_line_item: (data) => {
            return store.dispatch(remove_quote_cart_line_item(data))
        },
        select_all_quantity: (data) => {
            return store.dispatch(select_all_quantity(data))
        },
        set_schedule_date: (data) => {
            return store.dispatch(set_schedule_date(data))
        },
        set_quote_list_for_checkout: (quoteList) => {
            new QuoteDetailRepository().setQuoteOrderCheckoutList(quoteList);
        }
    };
    return [data, fetch, set]
}